import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import React__default, { useState } from 'react';
import { uniqueId } from '../../../utils/uniqueId.es.js';
import { TextInput } from '../../forms/TextInput/TextInput.es.js';

const root = "_root_n0w8p_1";
const inputField = "_input-field_n0w8p_16";
const styles = {
	root: root,
	inputField: inputField
};

const SubscriptionForm = (_a) => {
  var { inputIsFullWidth = true, fluidInput = false } = _a, props = __rest(_a, ["inputIsFullWidth", "fluidInput"]);
  const [id] = useState(props.inputId || uniqueId("SubscriptionForm-"));
  const [subscribedValue, setSubscribedValue] = useState("");
  const inputSize = "medium";
  const inputProps = {
    id,
    isDisabled: props.inputIsDisabled,
    isErrored: !!props.inputError,
    isRequired: props.inputIsRequired,
    isFullWidth: inputIsFullWidth,
    placeholder: props.placeholderText,
    ariaLabel: props.placeholderText,
    size: inputSize,
    onChange: (event) => setSubscribedValue(event.target.value)
  };
  return React__default.createElement(
    "form",
    { onSubmit: () => {
      var _a2;
      return (_a2 = props.onSubmit) === null || _a2 === void 0 ? void 0 : _a2.call(props, subscribedValue);
    }, "data-testid": "subscription-form", "data-zds": true },
    React__default.createElement(
      "div",
      { className: styles.root, "data-zds": true },
      React__default.createElement("div", { className: styles.inputField, "data-fluid-input": fluidInput ? true : void 0, "data-zds": true }, props.renderInput ? props.renderInput(inputProps) : React__default.createElement(TextInput, Object.assign({}, inputProps))),
      props.renderButton({ size: "medium" })
    )
  );
};

export { SubscriptionForm };
//# sourceMappingURL=SubscriptionForm.es.js.map
